import { stores } from '@kurtosys/app-start';
import { EventTypes } from '@kurtosys/event-manager/dist/models/EventTypes.js';
import { components } from '@kurtosys/ksys-app-components';
import { ILabelProps } from '@kurtosys/ksys-app-components/dist/models/charting/ILabelProps.js';
import { common } from '@kurtosys/ksys-app-template';
import { IManifest } from '@kurtosys/types/appsManager/index.js';
import { action, computed, makeObservable } from 'mobx';

import { IComponentStyles, IConfiguration, TStoreContext } from '../../../models/index.js';
import { AppStore } from '../../App/stores/AppStore.js';
import { InputStoreBase } from '../../shared/InputStoreBase.js';
import {
	IChangeAttestationComponentProps,
	IChangeAttestationConfiguration,
	IChangeAttestationOptions,
} from '../models/index.js';
type IButtonProps = components.base.Button.models.IButtonProps;

export class ChangeAttestationStore extends InputStoreBase<
	IChangeAttestationOptions,
	IChangeAttestationComponentProps,
	string
> {
	static componentKey = 'changeAttestation' as const;

	// unique instance id for change attestation implementation
	guid: string;

	appStore: AppStore;

	constructor(
		storeContext: TStoreContext,
		manifest: IManifest,
		inputKey: string,
		options: IChangeAttestationOptions,
		componentProps: IChangeAttestationComponentProps,
	) {
		super(storeContext, manifest, inputKey, options, componentProps);
		this.appStore = this.storeContext.get<AppStore>('appStore');
		this.guid = common.commonUtils.generateGuid();
		makeObservable(this);
	}

	// eslint-disable-next-line @typescript-eslint/no-empty-function
	initializeItems = async () => {};

	initializeValue = (): string => {
		return '';
	};

	@computed
	get hasData(): boolean {
		return true;
	}

	@computed
	get configuration(): IChangeAttestationConfiguration | undefined {
		if (this.appStore) {
			return this.appStore.getComponentConfiguration(ChangeAttestationStore.componentKey);
		}
	}

	@computed
	get buttonId(): string {
		return `change-attestation-button-${this.guid}`;
	}

	@computed
	get labelProps(): ILabelProps {
		return this.componentProps && this.componentProps.label;
	}

	@computed
	get buttonProps(): IButtonProps {
		const { button } = this.componentProps;
		const buttonProps: IButtonProps = this.mergeQueriesAndProps(button) || {
			text: 'Change Attestation',
		};
		buttonProps.onClick = this.changeAttestation;
		return buttonProps;
	}

	@action
	changeAttestation = () => {
		const eventBusStore =
			this.storeContext.get<stores.EventBusStore<IConfiguration, IComponentStyles>>('eventBusStore');
		eventBusStore.trigger({
			type: EventTypes.CHANGE_ATTESTATION,
			timestamp: new Date().getTime().toString()
		});

		const { analyticsHelper } = this.appStore;
		if (analyticsHelper) {
			analyticsHelper.logEvent({
				event: EventTypes.CHANGE_ATTESTATION,
				eventType: 'click',
				context: {
					url: window.location.href,
				},
			});
		}
	};

	@action
	// eslint-disable-next-line @typescript-eslint/no-empty-function
	async initialize(): Promise<void> {}
}
